import React, { Component } from "react";
import { Modal, Row, Col, Collapse, Icon } from "antd";
import "./Form.css";
import LogoFastGestor from '../imagens/logo-fastgestor-pequeno.png';
import { Link } from "react-router-dom";
import Colors from '../utils/Colors';

import CadastroRegistro from '../tutoriais/CadastroRegistro';
import CadProdutos from '../tutoriais/CadProdutos';
import CadServicos from '../tutoriais/CadServicos';
import CadPlanoConta from '../tutoriais/CadPlanoConta';
import CadTiposDoc from '../tutoriais/CadTiposDoc';
import CadCondPag from '../tutoriais/CadCondPag';

import OrdemServico from '../tutoriais/LancOrdemServico';
import LancCaixaLivre from '../tutoriais/LancCaixaLivre';
import LancVendas from '../tutoriais/LancVendas';
import LancPedidos from '../tutoriais/LancPedidos';
import LancOrcamentos from '../tutoriais/LancOrcamentos';
import LancCondicionais from '../tutoriais/LancCondicionais';
import LancRetornoCancelamento from '../tutoriais/LancRetornoCancelamento';

import LancNotasFiscais from '../tutoriais/LancNotasFiscais';

import LancCompras from '../tutoriais/LancCompras';
import LancAjusteEstoque from '../tutoriais/LancAjusteEstoque';
import LancEtiqueta from '../tutoriais/LancEtiqueta';

import Agenda from '../tutoriais/Agenda';

import LancLancamentosFinanceiros from '../tutoriais/LancLancamentosFinanceiros';
import LancReparcelamento from '../tutoriais/LancReparcelamento';

import RelCaixa from '../tutoriais/RelCaixa';
import RelBalancoFinanc from '../tutoriais/RelBalancoFinanc';
import RelContasPagRec from '../tutoriais/RelContasPagRec';


const Panel = Collapse.Panel;

const text = `
  A dog is a type of domesticated animal.
  Known for its loyalty and faithfulness,
  it can be found as a welcome guest in many households across the world.
`;

export default class AjudaForm extends Component {
  state = {
    modalOpenCadastroRegistro: false,
    modalOpenCadProdutos: false,
    modalOpenCadServicos: false,
    modalOpenCadPlanoConta: false,
    modalOpenCadTiposDoc: false,
    modalOpenCadCondPag: false,

    modalOpenLancCaixaLivre: false,
    modalOpenOrdemServico: false,
    modalOpenLancVendas: false,
    modalOpenLancOrcamentos: false,
    modalOpenLancPedidos: false,
    modalOpenLancCondicionais: false,
    modalOpenLancRetornoCancelamento: false,

    modalOpenLancNotasFiscais: false,

    modalOpenLancCompras: false,
    modalOpenLancAjusteEstoque: false,
    modalOpenLancEtiqueta: false,

    modalOpenLancAgenda: false,

    modalOpenLancLancamentosFinanceiros: false,
    modalOpenLancReparcelamento: false,

    modalOpenRelCaixa: false,
    modalOpenRelBalancoFinanc: false,
    modalOpenRelContasPagRec: false,

    modalOpen: false,
  };



  render() {
    const { onClose, carregando, visivel } = this.props;

    return (
      <Modal
        // title={"COMO POSSO AJUDAR?"}
        visible={visivel}
        destroyOnClose
        onCancel={onClose}
        footer={null}
        style={{ top: 30 }}
      >





        <Row>
          <div className="login-imagem" style={{ marginBottom: 20 }}>
            <img alt="Logo FastGestor" src={LogoFastGestor} style={{ width: 100, height: 100, marginBottom: 20 }} />
            <div>
              <span style={{ fontSize: 22, fontWeight: 'bold' }}>Como posso te ajudar?</span>
            </div>
          </div>
        </Row>
        <Row>

          <Collapse bordered={false} accordion style={{ fontSize: 18 }}>

            <Panel header="Como utilizar os cadastros do Sistema" key="1">
              <Row>
                <Link to="#" onClick={() => this.setState({ modalOpenCadastroRegistro: true })} style={{ color: Colors.accentLight }}>
                  <span style={{ fontSize: 16, marginLeft: 30 }}><Icon type='right' />  Cadastros Gerais do sistema</span>
                </Link>
              </Row>
              <Row>
                <Link to="#" onClick={() => this.setState({ modalOpenCadProdutos: true })} style={{ color: Colors.accentLight }}>
                  <span style={{ fontSize: 16, marginLeft: 30 }}><Icon type='right' />  Cadastro de Produtos</span>
                </Link>
              </Row>
              <Row>
                <Link to="#" onClick={() => this.setState({ modalOpenCadServicos: true })} style={{ color: Colors.accentLight }}>
                  <span style={{ fontSize: 16, marginLeft: 30 }}><Icon type='right' />  Cadastro de Serviços</span>
                </Link>
              </Row>
              <Row>
                <Link to="#" onClick={() => this.setState({ modalOpenCadPlanoConta: true })} style={{ color: Colors.accentLight }}>
                  <span style={{ fontSize: 16, marginLeft: 30 }}><Icon type='right' />  Cadastro de Planos de Contas Financeiro</span>
                </Link>
              </Row>
              <Row>
                <Link to="#" onClick={() => this.setState({ modalOpenCadTiposDoc: true })} style={{ color: Colors.accentLight }}>
                  <span style={{ fontSize: 16, marginLeft: 30 }}><Icon type='right' />  Cadastro de Tipos de Documentos</span>
                </Link>
              </Row>
              <Row>
                <Link to="#" onClick={() => this.setState({ modalOpenCadCondPag: true })} style={{ color: Colors.accentLight }}>
                  <span style={{ fontSize: 16, marginLeft: 30 }}><Icon type='right' />  Cadastro de Condições de Pagamentos</span>
                </Link>
              </Row>
            </Panel>


            <Panel header="Como fazer Vendas" key="2">
              <Row>
                <Link to="#" onClick={() => this.setState({ modalOpenLancCaixaLivre: true })} style={{ color: Colors.accentLight }}>
                  <span style={{ fontSize: 16, marginLeft: 30 }}><Icon type='right' />  Venda Balcão</span>
                </Link>
                <Link to="https://www.youtube.com/watch?v=ewANs5sG1X8&list=PLpe5WZ31yjQa5k3LuG7hBzmY1J-mOW3zz&index=7" target="_blank" style={{ color: Colors.accentLight }}>
                  <span style={{ fontSize: 18, marginLeft: 30 }}><Icon type='youtube' />  Video</span>
                </Link>
              </Row>
              <Row>
                <Link to="#" onClick={() => this.setState({ modalOpenOrdemServico: true })} style={{ color: Colors.accentLight }}>
                  <span style={{ fontSize: 16, marginLeft: 30 }}><Icon type='right' />  Ordem de Serviço</span>
                </Link>
                <Link to="https://www.youtube.com/watch?v=zfoLi03Bkus&list=PLpe5WZ31yjQa5k3LuG7hBzmY1J-mOW3zz&index=6" target="_blank" style={{ color: Colors.accentLight }}>
                  <span style={{ fontSize: 18, marginLeft: 30 }}><Icon type='youtube' />  Video</span>
                </Link>
              </Row>
              <Row>
                <Link to="#" onClick={() => this.setState({ modalOpenLancVendas: true })} style={{ color: Colors.accentLight }}>
                  <span style={{ fontSize: 18, marginLeft: 30 }}><Icon type='right' />  Gerenciar Vendas</span>
                </Link>
                <Link to="https://www.youtube.com/watch?v=yFCTeCgTASg&list=PLpe5WZ31yjQa5k3LuG7hBzmY1J-mOW3zz&index=2" target="_blank" style={{ color: Colors.accentLight }}>
                  <span style={{ fontSize: 18, marginLeft: 30 }}><Icon type='youtube' />  Video</span>
                </Link>
              </Row>
              <Row>
                <Link to="#" onClick={() => this.setState({ modalOpenLancPedidos: true })} style={{ color: Colors.accentLight }}>
                  <span style={{ fontSize: 18, marginLeft: 30 }}><Icon type='right' />  Pedidos</span>
                </Link>
              </Row>
              <Row>
                <Link to="#" onClick={() => this.setState({ modalOpenLancOrcamentos: true })} style={{ color: Colors.accentLight }}>
                  <span style={{ fontSize: 18, marginLeft: 30 }}><Icon type='right' />  Orçamentos</span>
                </Link>
              </Row>
              <Row>
                <Link to="#" onClick={() => this.setState({ modalOpenLancCondicionais: true })} style={{ color: Colors.accentLight }}>
                  <span style={{ fontSize: 18, marginLeft: 30 }}><Icon type='right' />  Condicionais</span>
                </Link>
              </Row>
              <Row>
                <Link to="#" onClick={() => this.setState({ modalOpenLancRetornoCancelamento: true })} style={{ color: Colors.accentLight }}>
                  <span style={{ fontSize: 18, marginLeft: 30 }}><Icon type='right' />  Estorno/Cancelamento de Vendas</span>
                </Link>
              </Row>
            </Panel>


            <Panel header="Como emitir Notas Fiscais" key="3">
              <Row>
                <Link to="#" onClick={() => this.setState({ modalOpenLancNotasFiscais: true })} style={{ color: Colors.accentLight }}>
                  <span style={{ fontSize: 18, marginLeft: 30 }}><Icon type='right' />  Notas Fiscais</span>
                </Link>
              </Row>
              <Row>
                <Link to="https://www.youtube.com/watch?v=T9s-VeRas14&list=PLpe5WZ31yjQa5k3LuG7hBzmY1J-mOW3zz&index=3" target="_blank" style={{ color: Colors.accentLight }}>
                  <span style={{ fontSize: 18, marginLeft: 30 }}><Icon type='youtube' />  Video NF Produtos</span>
                </Link>
              </Row>
              <Row>
                <Link to="https://www.youtube.com/watch?v=9gyi9kzIFGs&list=PLpe5WZ31yjQa5k3LuG7hBzmY1J-mOW3zz&index=4" target="_blank" style={{ color: Colors.accentLight }}>
                  <span style={{ fontSize: 18, marginLeft: 30 }}><Icon type='youtube' />  Video NF Serviços</span>
                </Link>
              </Row>

            </Panel>


            <Panel header="Estoque" key="4">
              <Row>
                <Link to="#" onClick={() => this.setState({ modalOpenLancCompras: true })} style={{ color: Colors.accentLight }}>
                  <span style={{ fontSize: 18, marginLeft: 30 }}><Icon type='right' />  Compras</span>
                </Link>
              </Row>
              <Row>
                <Link to="#" onClick={() => this.setState({ modalOpenLancAjusteEstoque: true })} style={{ color: Colors.accentLight }}>
                  <span style={{ fontSize: 18, marginLeft: 30 }}><Icon type='right' />  Ajuste de Estoque</span>
                </Link>
              </Row>
              <Row>
                <Link to="#" onClick={() => this.setState({ modalOpenLancEtiqueta: true })} style={{ color: Colors.accentLight }}>
                  <span style={{ fontSize: 18, marginLeft: 30 }}><Icon type='right' />  Impressão de Etiquetas</span>
                </Link>
              </Row>
            </Panel>


            <Panel header="Como utilizar a Agenda" key="5">
              <Row>
                <Link to="#" onClick={() => this.setState({ modalOpenLancAgenda: true })} style={{ color: Colors.accentLight }}>
                  <span style={{ fontSize: 18, marginLeft: 30 }}><Icon type='right' />  Agenda</span>
                </Link>
              </Row>
            </Panel>


            <Panel header="Módulo Financeiro" key="6">
              <Row>
                <Link to="#" onClick={() => this.setState({ modalOpenLancLancamentosFinanceiros: true })} style={{ color: Colors.accentLight }}>
                  <span style={{ fontSize: 18, marginLeft: 30 }}><Icon type='right' />  Lançamentos Financeiros</span>
                </Link>
                <Link to="https://www.youtube.com/watch?v=19ewFo5Oqh8&list=PLpe5WZ31yjQa5k3LuG7hBzmY1J-mOW3zz&index=8" target="_blank" style={{ color: Colors.accentLight }}>
                  <span style={{ fontSize: 18, marginLeft: 30 }}><Icon type='youtube' />  Video</span>
                </Link>
              </Row>
              <Row>
                <Link to="#" onClick={() => this.setState({ modalOpenLancReparcelamento: true })} style={{ color: Colors.accentLight }}>
                  <span style={{ fontSize: 18, marginLeft: 30 }}><Icon type='right' />  Reparcelamento Financeiro</span>
                </Link>
                <Link to="https://www.youtube.com/watch?v=rFODcKXLgMs&list=PLpe5WZ31yjQa5k3LuG7hBzmY1J-mOW3zz&index=5" target="_blank" style={{ color: Colors.accentLight }}>
                  <span style={{ fontSize: 18, marginLeft: 30 }}><Icon type='youtube' />  Video</span>
                </Link>
              </Row>
            </Panel>


            <Panel header=" Relatórios do Sistema" key="7">
              <Row>
                <Link to="#" onClick={() => this.setState({ modalOpenRelCaixa: true })} style={{ color: Colors.accentLight }}>
                  <span style={{ fontSize: 18, marginLeft: 30 }}><Icon type='right' />  Caixa</span>
                </Link>
                <Link to="https://www.youtube.com/watch?v=Op8desSkMtA&list=PLpe5WZ31yjQa5k3LuG7hBzmY1J-mOW3zz" target="_blank" style={{ color: Colors.accentLight }}>
                  <span style={{ fontSize: 18, marginLeft: 30 }}><Icon type='youtube' />  Video</span>
                </Link>
              </Row>
              <Row>
                <Link to="#" onClick={() => this.setState({ modalOpenRelBalancoFinanc: true })} style={{ color: Colors.accentLight }}>
                  <span style={{ fontSize: 18, marginLeft: 30 }}><Icon type='right' />  Balanço Financeiro</span>
                </Link>
              </Row>
              <Row>
                <Link to="#" onClick={() => this.setState({ modalOpenRelContasPagRec: true })} style={{ color: Colors.accentLight }}>
                  <span style={{ fontSize: 18, marginLeft: 30 }}><Icon type='right' />  Contas à Pagar e Receber</span>
                </Link>
              </Row>
            </Panel>
          </Collapse>

        </Row>



        <CadastroRegistro
          isOpen={this.state.modalOpenCadastroRegistro}
          onClose={() => this.setState({ modalOpenCadastroRegistro: false })}
        />
        <CadProdutos
          isOpen={this.state.modalOpenCadProdutos}
          onClose={() => this.setState({ modalOpenCadProdutos: false })}
        />
        <CadServicos
          isOpen={this.state.modalOpenCadServicos}
          onClose={() => this.setState({ modalOpenCadServicos: false })}
        />
        <CadPlanoConta
          isOpen={this.state.modalOpenCadPlanoConta}
          onClose={() => this.setState({ modalOpenCadPlanoConta: false })}
        />
        <CadTiposDoc
          isOpen={this.state.modalOpenCadTiposDoc}
          onClose={() => this.setState({ modalOpenCadTiposDoc: false })}
        />
        <CadCondPag
          isOpen={this.state.modalOpenCadCondPag}
          onClose={() => this.setState({ modalOpenCadCondPag: false })}
        />


        <LancCaixaLivre
          isOpen={this.state.modalOpenLancCaixaLivre}
          onClose={() => this.setState({ modalOpenLancCaixaLivre: false })}
        />
        <OrdemServico
          isOpen={this.state.modalOpenOrdemServico}
          onClose={() => this.setState({ modalOpenOrdemServico: false })}
        />
        <LancVendas
          isOpen={this.state.modalOpenLancVendas}
          onClose={() => this.setState({ modalOpenLancVendas: false })}
        />
        <LancPedidos
          isOpen={this.state.modalOpenLancPedidos}
          onClose={() => this.setState({ modalOpenLancPedidos: false })}
        />
        <LancOrcamentos
          isOpen={this.state.modalOpenLancOrcamentos}
          onClose={() => this.setState({ modalOpenLancOrcamentos: false })}
        />
        <LancCondicionais
          isOpen={this.state.modalOpenLancCondicionais}
          onClose={() => this.setState({ modalOpenLancCondicionais: false })}
        />
        <LancRetornoCancelamento
          isOpen={this.state.modalOpenLancRetornoCancelamento}
          onClose={() => this.setState({ modalOpenLancRetornoCancelamento: false })}
        />


        <LancNotasFiscais
          isOpen={this.state.modalOpenLancNotasFiscais}
          onClose={() => this.setState({ modalOpenLancNotasFiscais: false })}
        />


        <LancCompras
          isOpen={this.state.modalOpenLancCompras}
          onClose={() => this.setState({ modalOpenLancCompras: false })}
        />
        <LancAjusteEstoque
          isOpen={this.state.modalOpenLancAjusteEstoque}
          onClose={() => this.setState({ modalOpenLancAjusteEstoque: false })}
        />
        <LancEtiqueta
          isOpen={this.state.modalOpenLancEtiqueta}
          onClose={() => this.setState({ modalOpenLancEtiqueta: false })}
        />


        <Agenda
          isOpen={this.state.modalOpenLancAgenda}
          onClose={() => this.setState({ modalOpenLancAgenda: false })}
        />


        <LancLancamentosFinanceiros
          isOpen={this.state.modalOpenLancLancamentosFinanceiros}
          onClose={() => this.setState({ modalOpenLancLancamentosFinanceiros: false })}
        />
        <LancReparcelamento
          isOpen={this.state.modalOpenLancReparcelamento}
          onClose={() => this.setState({ modalOpenLancReparcelamento: false })}
        />


        <RelCaixa
          isOpen={this.state.modalOpenRelCaixa}
          onClose={() => this.setState({ modalOpenRelCaixa: false })}
        />
        <RelBalancoFinanc
          isOpen={this.state.modalOpenRelBalancoFinanc}
          onClose={() => this.setState({ modalOpenRelBalancoFinanc: false })}
        />
        <RelContasPagRec
          isOpen={this.state.modalOpenRelContasPagRec}
          onClose={() => this.setState({ modalOpenRelContasPagRec: false })}
        />


      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/AjudaForm.js